import React, { ReactNode } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { ThumbUpAltOutlined } from '@mui/icons-material';

interface Props {
  isVisible: boolean;
  message: string | ReactNode;
  onConfirm?: () => void;
  onClose?: () => void;
}

const ApproveWarningDialog: React.FC<Props> = (props: Props) => {
  return (
    <Dialog open={props.isVisible} onClose={props.onClose}>
      <DialogTitle className="text-xl text-neutral-600 !font-bold">Varning</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.message}</DialogContentText>
      </DialogContent>
      <DialogActions className="!px-[20px] !py-[24px] !justify-between">
        <Button className="w-52 h-12" variant="outlined" color="error" onClick={props.onClose}>
          Avbryt
        </Button>

        <Button
          className="w-52 h-13"
          variant="contained"
          color="primary"
          endIcon={<ThumbUpAltOutlined />}
          sx={{
            '&.Mui-disabled': {
              backgroundColor: '#43967680',
              color: 'white',
              opacity: 1,
            },
          }}
          onClick={props.onConfirm}
        >
          Godkänn ändå
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveWarningDialog;
